import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
   // alert(JSON.stringify(formData));
    const response = await axios.post(
      "https://inryde.in/dashboard/contact",
      {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        message: formData.message,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //alert(JSON.stringify(response));
      alert(response.data.message);
      setFormData({name:"",email:"",mobile:"",message:""})
    

    

  } catch (error) {
    console.error(error);
    alert("Server error");
  }
};


  // Theme colors and fonts (inline style reference)
  const colors = {
    primaryRed: "#E63946",
    secondaryYellow: "#FFC300",
    backgroundLight: "#F8F9FA",
    textPrimary: "#1C1C1C",
    textSecondary: "#6C757D",
    white: "#FFFFFF",
    gradient: "linear-gradient(90deg, #E63946, #FFC300)",
  };

  const fonts = {
    heading: "'Poppins', sans-serif",
    body: "'Inter', sans-serif",
  };

  return (
    <section
      id="contactus"
      style={{
        minHeight: "100vh",
        padding: "80px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: fonts.body,
        position: "relative",
        background: colors.backgroundLight,
        overflow: "hidden",
      }}
    >
      {/* Glowing gradient circles */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.3 }}
        transition={{ duration: 1.5 }}
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          background: colors.gradient,
          borderRadius: "50%",
          top: "-100px",
          left: "-100px",
          filter: "blur(140px)",
          zIndex: 0,
        }}
      />
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.3 }}
        transition={{ duration: 1.5, delay: 0.3 }}
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          background: colors.gradient,
          borderRadius: "50%",
          bottom: "-100px",
          right: "-100px",
          filter: "blur(140px)",
          zIndex: 0,
        }}
      />

      {/* Heading */}
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          fontFamily: fonts.heading,
          fontSize: "clamp(34px, 6vw, 50px)",
          marginBottom: "10px",
          background: colors.gradient,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textAlign: "center",
          letterSpacing: "1px",
          zIndex: 2,
        }}
      >
        GET IN TOUCH
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        style={{
          color: colors.textSecondary,
          marginBottom: "50px",
          textAlign: "center",
          maxWidth: "600px",
          fontSize: "17px",
          zIndex: 2,
        }}
      >
        Have a question, feedback, or want to join our community? We’d love to
        hear from you — drop your details below!
      </motion.p>

      {/* Contact Form */}
      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        style={{
          width: "100%",
          maxWidth: "650px",
          background: colors.white,
          padding: "45px 35px",
          borderRadius: "20px",
          boxShadow: "0 10px 35px rgba(0,0,0,0.12)",
          display: "flex",
          flexDirection: "column",
          gap: "22px",
          position: "relative",
          zIndex: 2,
          borderTop: `5px solid ${colors.primaryRed}`,
        }}
      >
        {[
          { label: "Name", name: "name", type: "text", placeholder: "Enter your name" },
          { label: "Email Address", name: "email", type: "email", placeholder: "Enter your email" },
          { label: "Mobile Number", name: "mobile", type: "tel", placeholder: "Enter your mobile number" },
        ].map((field, i) => (
          <div
            key={i}
            style={{ display: "flex", flexDirection: "column", textAlign: "left" }}
          >
            <label
              style={{
                fontWeight: "600",
                marginBottom: "8px",
                color: colors.textPrimary,
              }}
            >
              {field.label}:
            </label>
            <input
              type={field.type}
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              required
              placeholder={field.placeholder}
              style={{
                padding: "13px 14px",
                border: "1.8px solid #ddd",
                borderRadius: "10px",
                fontSize: "15px",
                outline: "none",
                transition: "all 0.3s ease",
              }}
              onFocus={(e) => (e.target.style.borderColor = colors.primaryRed)}
              onBlur={(e) => (e.target.style.borderColor = "#ddd")}
            />
          </div>
        ))}

        {/* Role
        <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
          <label
            style={{
              fontWeight: "600",
              marginBottom: "8px",
              color: colors.textPrimary,
            }}
          >
            You are a:
          </label>
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
            style={{
              padding: "13px 14px",
              border: "1.8px solid #ddd",
              borderRadius: "10px",
              fontSize: "15px",
              backgroundColor: colors.white,
              outline: "none",
              transition: "all 0.3s ease",
            }}
            onFocus={(e) => (e.target.style.borderColor = colors.primaryRed)}
            onBlur={(e) => (e.target.style.borderColor = "#ddd")}
          >
            <option value="">- Select -</option>
            <option value="Captain">Captain</option>
            <option value="Customer">Customer</option>
          </select>
        </div> */}

        {/* Comment */}
        <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
          <label
            style={{
              fontWeight: "600",
              marginBottom: "8px",
              color: colors.textPrimary,
            }}
          >
            Message:
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            placeholder="Write your message here..."
            rows="4"
            style={{
              padding: "13px 14px",
              border: "1.8px solid #ddd",
              borderRadius: "10px",
              fontSize: "15px",
              resize: "none",
              outline: "none",
              transition: "all 0.3s ease",
            }}
            onFocus={(e) => (e.target.style.borderColor = colors.primaryRed)}
            onBlur={(e) => (e.target.style.borderColor = "#ddd")}
          />
        </div>

        {/* Submit Button */}
        <motion.button
          type="submit"
          
          whileHover={{
            scale: 1.05,
            boxShadow: `0 0 20px ${colors.primaryRed}55`,
          }}
          whileTap={{ scale: 0.95 }}
          style={{
            marginTop: "10px",
            background: colors.gradient,
            color: colors.white,
            border: "none",
            padding: "14px",
            borderRadius: "50px",
            fontWeight: "600",
            fontSize: "16px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
            letterSpacing: "1px",
          }}
        >
          SUBMIT
        </motion.button>
      </motion.form>
    </section>
  );
}
